export default "__VITE_ASSET__nKwvuz5$__"